<template>
    <app-layout>
        <base-header :shadow="false" border border-bg-from="from-sky-500" border-bg-to="to-indigo-500">
            <div class="flex items-center justify-between w-full">
                <h4 class="text-xl font-medium">
                    {{ $t('general.user') }}
                </h4>
                <default-button :href="route('users.create')" size="sm" icon="plus">
                    {{ $t('user.create') }}
                </default-button>
            </div>
        </base-header>

        <template>
            <table-base class="text-sm" :busy="isLoading">
                <template #head>
                    <table-head>{{ $t('general.name') }}</table-head>
                    <table-head>{{ $t('general.email') }}</table-head>
                    <table-head>{{ $t('user.active') }}</table-head>
                    <table-head>{{ $t('general.stores') }}</table-head>
                    <table-head></table-head>
                </template>
                <template #body>
                    <table-row v-for="user in users.data" :key="user.id">
                        <table-cell>
                            <div class="flex items-center">
                                <!--<div-->
                                <!--    class="flex justify-center flex-wrap content-center h-10 w-10 rounded-full flex-shrink-0 text-gray-300 bg-gray-800 mr-2">-->
                                <!--    <img-->
                                <!--        :src="user.profile_photo_path ? user.profile_photo_path : user.profile_photo_url + '&rounded=true'"-->
                                <!--        alt="Profile Photo">-->
                                <!--</div>-->
                                <div>
                                    <h2 class="font-medium">{{ user.name }}</h2>
                                </div>
                            </div>
                        </table-cell>
                        <table-cell>
                            {{ user.email }}
                        </table-cell>
                        <table-cell>
                            <icon v-if="user.active" :size="6" name="check-circle"
                                  class-icon="text-green-600"></icon>
                            <icon v-else :size="6" name="x-circle" class-icon="text-red-600"></icon>
                        </table-cell>
                        <table-cell>
                            <template v-if="user.stores.length > 0">
                                <div class="space-x-1 space-y-1">
                                    <span v-for="store in user.stores" class="py-1 px-2 rounded-lg bg-teal-600 font-bold">
                                        #{{ store.number }}
                                    </span>
                                </div>
                            </template>
                        </table-cell>
                        <table-cell class="flex justify-end space-x-1">
                            <default-button icon="pencil" size="xs" :label="$t('form.edit')" :href="route('users.edit', user.id)"/>
                            <delete-button :loading="isDeleting.includes(user.id)"
                                           :modal-title="$t('user.delete')"
                                           @delete="deleteUser(user.id)"
                            >
                                <template #modal-body>
                                    {{ $t('store.delete_confirm') }}
                                </template>
                            </delete-button>
                        </table-cell>
                    </table-row>
                </template>
            </table-base>
            <table-pagination v-if="users && users.meta" :meta="users.meta.pagination" :links="users.links"
                              @paginate="loadPage"
            />
        </template>
    </app-layout>
</template>

<script>
import User from '@/Models/User';

export default {
    metaInfo() {
        return {
            title: this.$t('general.users'),
        };
    },

    data() {
        return {
            isLoading: false,
            isDeleting: [],
            page: 1,
            users: {},
        };
    },

    async created() {
        await this.loadPage(1);
    },

    methods: {
        async loadPage(page) {
            this.page = page;
            await this.applyQuery();
        },

        async applyQuery() {
            this.isLoading = true;
            this.users = await User.include(['stores']).pageNumber(this.page).orderBy(this.sortQuery).all();
            this.isLoading = false;
        },

        deleteUser(id) {
            this.isDeleting.push(id);

            axios.post(route('users.destroy', id), {
                _method: 'DELETE',
            }).then(() => {
                this.isDeleting = this.isDeleting.filter(item => item !== id);
                this.$inertia.reload({
                    preserveState: true,
                    preserveScroll: true,
                    only: ['users'],
                });
            });
        },
    },
};
</script>
